
  $(document).on('click','.product-card-wrapper .swatch-input__label',function(){
      let variantID = $(this).attr("data-tier-variant-id")
      let productCardClosestParent = $(this).closest('.card__content')
      productCardClosestParent.find('.swatch-input__label').removeClass('selected')
      $(this).addClass('selected')
      productCardClosestParent.find('product-form .product-variant-id').val(variantID)
  })
  $(document).on('click', '.cr_show-filter--cta a', function(){
      $('.facets-vertical #main-collection-filters').toggleClass('active');
    $('.facets-vertical #ProductGridContainer').toggleClass('active');
  })

 $(document).ready(function () {
   const isArabic = document.documentElement.lang === 'ar';
   $('.card-slider').slick({
    rtl: isArabic,
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
     autoplay:false,
     arrows:true,
     prevArrow: '<button type="button" class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0618/3534/6016/files/Group_88.svg?v=1740966311" alt="Previous"></button>',
     nextArrow: '<button type="button" class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0618/3534/6016/files/Group_22.svg?v=1740966310" alt="Next"></button>',
     responsive: [
       {
        breakpoint: 1600,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: true
        }
      },
      {
        breakpoint: 1150,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: true
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          dots: true,
          arrows:false
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });

  $('.testimonials-list').slick({
  rtl: isArabic,
  dots: true,
  infinite: true,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 1,
   autoplay:false,
   arrows:true,
   prevArrow: '<button type="button" class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0618/3534/6016/files/Group_88.svg?v=1740966311" alt="Previous"></button>',
  nextArrow: '<button type="button" class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0618/3534/6016/files/Group_22.svg?v=1740966310" alt="Next"></button>',
  responsive: [
     {
      breakpoint: 1600,
      settings: {
       slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true
      }
    },
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true
      }
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        dots: true,
        arrows:false
      }
    },
      {
      breakpoint: 575,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows:false
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
 });

      
 // $('.testimonials-list').slick({
 //    rtl: isArabic,
 //   slidesToShow: 1,
 //   autoplay:false,
 //   arrows:true,
 //  prevArrow: '<button type="button" class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0618/3534/6016/files/Group_88.svg?v=1740966311" alt="Previous"></button>',
 //  nextArrow: '<button type="button" class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0618/3534/6016/files/Group_22.svg?v=1740966310" alt="Next"></button>',
 //  responsive: [
 //     {
 //      breakpoint: 1050,
 //      settings: {
 //        centerMode: true,
 //        centerPadding: '50px'
 //      }
 //    },
 //    {
 //      breakpoint: 768,
 //      settings: {
 //        centerMode: true,
 //        centerPadding: '50px'
 //      }
 //    },
 //    {
 //      breakpoint: 480,
 //      settings: {
 //        centerMode: true,
 //        centerPadding: '40px'
 //      }
 //    }
 //  ]
 //});

   $('.best-card-slider').slick({
    rtl: isArabic,
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
     autoplay:false,
     arrows:true,
     prevArrow: '<button type="button" class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0618/3534/6016/files/Group_88.svg?v=1740966311" alt="Previous"></button>',
    nextArrow: '<button type="button" class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0618/3534/6016/files/Group_22.svg?v=1740966310" alt="Next"></button>',
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          dots: true,
          arrows:false
        }
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 2, 
          slidesToScroll: 1, 
          dots: true,
          arrows: false
        }
      }
    ]
  });
      

  $('.event-collection').slick({
     rtl: isArabic,
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
     autoplay:false,
     arrows:false,
    responsive: [
      {
        breakpoint: 1150,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
  $('.best-seller-collection').slick({
     rtl: isArabic,
      dots: false,
      infinite: true,
      speed: 300,
      slidesToShow: 2,
      slidesToScroll: 1,
       autoplay:false,
       arrows:true,
      prevArrow: '<button type="button" class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0618/3534/6016/files/Group_21_1.svg?v=1742559309" alt="Previous"></button>',
      nextArrow: '<button type="button" class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0618/3534/6016/files/Group_22_1.svg?v=1742559309" alt="Next"></button>',
      responsive: [
        {
          breakpoint: 1150,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
   
    $('.slick-slider.hero-banner').slick({
      rtl: isArabic,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 3000,
      speed: 700,
      arrows: true,
      prevArrow: '<button type="button" class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0618/3534/6016/files/Arrow_2.svg?v=1740827487" alt="Previous"></button>',
      nextArrow: '<button type="button" class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0618/3534/6016/files/Arrow_3.svg?v=1740827488" alt="Next"></button>',
      dots: true,
      infinite: true,
      adaptiveHeight: true
    });
  
   const buttons = $(".tab-button");
   const contents = $(".tab-content");

      function initSlick($slider) {
          if ($slider.hasClass("slick-initialized")) {
              $slider.slick("unslick"); // Destroy existing instance before reinitializing
          }

          $slider.slick({
               rtl: isArabic,
              slidesToShow: 4, 
              slidesToScroll: 1,
              autoplay: false,
              dots: true,
              arrows: true,
              infinite: true,
              prevArrow: '<button type="button" class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0618/3534/6016/files/Group_88.svg?v=1740966311" alt="Previous"></button>',
              nextArrow: '<button type="button" class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0618/3534/6016/files/Group_22.svg?v=1740966310" alt="Next"></button>',
              responsive: [
              {
                  breakpoint: 1200,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true
                  }
                },
                {
                  breakpoint: 1024,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    dots: false,
                    arrows:true
                  }
                },
                {
                  breakpoint: 575,
                  settings: {
                    slidesToShow: 2, 
                    slidesToScroll: 1,
                    dots: false,
                    arrows: true
                  } 
                }
              ]
          });

          setTimeout(() => {
              $slider.slick("setPosition"); // Ensures proper rendering
          }, 100);
      }

      function showTab(index) {
          buttons.removeClass("active");
          contents.removeClass("active").hide();

          buttons.eq(index).addClass("active");
          const $activeTab = contents.eq(index).fadeIn(300).addClass("active");

          const $slider = $activeTab.find(".products-slider");

          // Fix reinitialization issue
          setTimeout(() => {
              initSlick($slider);
          }, 200); // Delayed to ensure correct width calculation
      }

      $(".tab-content").each(function (index) {
          const $slider = $(this).find(".products-slider");
          if (index === 0) {
              $(this).show();
              initSlick($slider);
          } else {
              $(this).hide();
          }
      });

      buttons.each(function (index) {
          $(this).on("click", function () {
              showTab(index);
          });
      });

// const buttons = $(".tab-button");
// const contents = $(".tab-content");

// // Initialize Slick only once
// function initSlick($slider) {
//     if ($slider.hasClass("slick-initialized")) return;

//     $slider.slick({
//         rtl: isArabic,
//         slidesToShow: 4,
//         slidesToScroll: 1,
//         autoplay: false,
//         dots: true,
//         arrows: true,
//         infinite: true,
//         prevArrow: '<button type="button" class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0618/3534/6016/files/Group_88.svg?v=1740966311" alt="Previous"></button>',
//         nextArrow: '<button type="button" class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0618/3534/6016/files/Group_22.svg?v=1740966310" alt="Next"></button>',
//         responsive: [
//             {
//                 breakpoint: 1200,
//                 settings: { slidesToShow: 3 }
//             },
//             {
//                 breakpoint: 1024,
//                 settings: { slidesToShow: 2, arrows: false }
//             },
//             {
//                 breakpoint: 575,
//                 settings: { slidesToShow: 1, arrows: false }
//             }
//         ]
//     });
// }

// // 💡 Force visibility temporarily to initialize hidden sliders
// contents.each(function (index) {
//     const $tab = $(this);
//     const $slider = $tab.find(".products-slider");

//     const isHidden = !$tab.is(":visible");
//     if (isHidden) {
//         $tab.css({ visibility: "hidden", display: "block", position: "absolute" });
//     }

//     initSlick($slider);

//     if (isHidden) {
//         $tab.removeAttr("style").hide();
//     } else {
//         $tab.show().addClass("active");
//     }
// });

// // 👉 Handle tab switching (only show/hide — no slider logic)
// buttons.each(function (index) {
//     $(this).on("click", function () {
//         buttons.removeClass("active");
//         contents.removeClass("active").hide();

//         buttons.eq(index).addClass("active");
//         contents.eq(index).fadeIn(300).addClass("active");

//         // Ensure layout is fixed
//         const $slider = contents.eq(index).find(".products-slider");
//         $slider.slick("setPosition");
//     });
// });



// document.addEventListener('DOMContentLoaded', function () {
//     var splide = new Splide('.splide', {
//         type       : 'loop',
//         perPage    : 3,
//         perMove    : 1,
//         focus      : 'center',
//         autoplay   : true,
//         interval   : 3000,
//         pauseOnHover: true,
//         arrows     : true,
//         pagination : false, // Disable default dots
//         gap        : '20px',
//         breakpoints: {
//             1024: { perPage: 2, gap: '15px' },
//             768 : { perPage: 1, gap: '10px' }
//         }
//     });

//     splide.mount();

//     // Custom Pagination
//     var paginationContainer = document.createElement('div');
//     paginationContainer.classList.add('custom-pagination');
//     document.querySelector('.splide').appendChild(paginationContainer);

//     function updatePagination() {
//         var currentPage = splide.index + 1; // Current Slide
//         var totalPages = splide.length; // Total Slides
//         paginationContainer.innerHTML = `<span>${currentPage} / ${totalPages}</span>`;
//     }

//     splide.on('moved', updatePagination);
//     updatePagination(); // Initial Update
// });   
});